<template>
    <v-app style="background: #eee" class="pa-3">
		<div>
			<span class="display-1 font-weight-light"> Accepted Bids </span>
			<v-divider/>
			<br />
			<v-layout row wrap>
				<span v-if="accepted.length==0" class="subheading">You have no accepted bids.</span>
				<v-flex v-for="(post,index) in accepted" xs12 sm6 md4>
					<div class="mr-4 ml-4 mt-4">
						<AcceptedBidCard
							:posted_by=post.data().posted_by
							:item_name=post.data().item_name
                            :marked_price="Number(post.data().marked_price)"
                            :photos=post.data().photos
                            :category=post.data().category
                            :postId=post.id
							:bid="acceptedBids[index]"
						></AcceptedBidCard>
					</div>
				</v-flex>
			</v-layout>
		</div>
		
		<div class="pt-4">
			<span class="display-1 font-weight-light"> Requested Bids </span>
			<v-divider/>
			<br />
			<v-layout row wrap>
				<span v-if="requested.length==0" class="subheading">You have no pending bids.</span>
				<v-flex v-for="(post, i) in requested" xs12 sm6 md4>
					<div class="mr-4 ml-4 mt-4">
						<BidCard
							:posted_by=post.data().posted_by
							:item_name=post.data().item_name
                            :marked_price="Number(post.data().marked_price)"
                            :photos=post.data().photos
                            :category=post.data().category
                            :postId=post.id
							:bid="requestedBids[i]"
						></BidCard>
					</div>
				</v-flex>
			</v-layout>
		</div>

	</v-app>
</template>

<script>
import BidCard from '@/components/BidCard.vue'
import AcceptedBidCard from '@/components/AcceptedBidCard.vue'
import firebase from 'firebase'

export default {
	components:{
		BidCard,
		AcceptedBidCard
	},

	data(){
		return {
			listener: null,
			requested: [],
			accepted: [],
			requestedBids: [],
			acceptedBids: []
		}
	},
	beforeDestroy(){
		var vm=this;
		vm.listener();
	},

	created: function(){
		const db = firebase.firestore();
		var vm = this;
		vm.listener = db.collection('users').doc(firebase.auth().currentUser.uid)
		.onSnapshot(function(doc){
			var tempRequested = [];
			var tempAccepted = [];
			var tempRejected = [];
			for (var postId of doc.data().interested){
				db.collection('posts_buy').doc(postId.id).get()
				.then(function(postDoc){
					tempRequested.push(postDoc)
					vm.requestedBids.push(postId.bid)
				})
			}
			for (var postId of doc.data().accepted_buy){
				db.collection('posts_buy').doc(postId.id).get()
				.then(function(postDoc){
					tempAccepted.push(postDoc)
					vm.acceptedBids.push(postId.bid)
				})
			}
			vm.accepted = tempAccepted;
			vm.requested = tempRequested;
		});
	}
};
</script>
